export enum ESceneState {
  NONE = 0,
  INITIALIZED = 1,
  STARTING = 2,
  LOADING = 3,
  LOADED = 4,
  RUNNING = 5,
  PAUSED = 6,
  STOPPED = 7,
  DESTROYED = 8
}
